const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'GET_VENDOR_DETAILS': {
      return {
        ...state,
        vendorDetails: action.data,
      };
    }
    case 'SET_COUNTRY_CODE': {
      return {
        ...state,
        countryCodes: action.data,
      };
    }
    case 'GET_GSTIN_DETAILS': {
      return {
        ...state,
        gstFetchedFailed: false,
      };
    }
    case 'SET_GSTIN_DETAILS': {
      return {
        ...state,
        vendorList: action.data,
        gstFetchedFailed: action.gstFetchedFailed,
      };
    }
    case 'SET_VENDOR_DETAILS': {
      return {
        ...state,
        editVendorDetails: action.data.object_data
          ? { ...action.data.object_data.vendor }
          : { ...action.data.vendor },
        workflowDetails: action.data.object_data ? { ...action.data } : {},
        cityState: [],
      };
    }
    case 'SET_CITY_STATE': {
      return {
        ...state,
        cityState: action.data,
      };
    }
    case 'SET_WORKFLOW_COMMENT': {
      return {
        ...state,
        comment: action.data,
      };
    }
    case 'SET_IFSC_BANK_DETAILS': {
      return {
        ...state,
        ifscBankDetails: action.payload.error
          ? action.payload
          : action.payload.bank,
      };
    }
    case 'SET_CHEQUE_DETAILS': {
      return {
        ...state,
        ocrData: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
